import { Action } from '@ngrx/store';

export enum AppActionTypes {
  Language = '[App] Language',
}

export class AppLanguageAction implements Action {
  readonly type = AppActionTypes.Language;
  constructor(public data: string) {}
}
